import { CheckboxProps as MUICheckboxProps } from '@mui/material'
import { StyledCheckbox } from './styles'
import { IFieldStatus } from '@/main/interfaces'

interface CheckboxProps extends MUICheckboxProps, IFieldStatus {}

export function Checkbox({ blocked, disabled, ...props }: CheckboxProps) {
  return <StyledCheckbox disableRipple={true} disabled={disabled || blocked} {...props} />
}
